<template v-if ="mng">
  <div id="transit">
    <div  class="card-header d-flex flex-wrap justify-content-between align-self-stretch animated flash"
    >
     <div v-if="!isInvoice" > Заказ у поставщика №
      {{ supplierTransit }} от {{ supplierTransitOrder.UpdateAt }}
    </div>
     <div v-if="isInvoice" > НАКЛАДНАЯ №
        {{ supplierInvoice }} от {{ supplierTransitOrder.UpdateAt }}
     </div>
     </div>
    <div class="row">
      <div
        v-for="(good, index) in supplierTransitOrder.Products"
        :key="index"
        class="card col-md-12 mb-2 cascading-admin-card animated fadeIn"
        :id="index"
        >
        <div
          class="card-header d-flex flex-wrap justify-content-between align-self-stretch animated fadeIn"
          v-bind:class="{ 'green lighten-5': good.Status === 'Собран' }"
        >
          <b>{{ index + 1 }}.</b> {{ good.Code }}
          <input class="form-control col-3" type="text" v-model.lazy="good.Articul" title="Артикул">
        <button type="btn btn-sm" class="input-group-text hoverable btn-primary" @click.prevent="changeArticle(good.Code,good.Articul)"
             title="Изменить"><i class="fa fa-edit"></i>
        </button>
        </div>
        <div
          class="card-body animated fadeIn"
          v-bind:class="{
            'green lighten-5': good.Status === 'Собран',
          }"
        >
          <!-- Text -->
          <div
            class="card-text animated fadeIn"
            v-bind:class="{ 'black-text': good.OrderedQty > 0 }"
          >
            <span class = "black-text" title="Публичное наименование поставщика" >{{ good.Naim }}</span><br>
            <span class = "blue-text" title="Бухнаименование поставщика" >{{ good.BuhNaim }}</span><br>
            <span class = "red-text" title="Бухнаименование в нашей базе" >{{ good.НаименованиеПолное }}</span>
          </div>
        </div>
        <div class="card-footer d-flex flex-wrap justify-content-end animated fadeIn">
          <div class="input-group-prepend col">
            <span
              class=" input-group-text special-color text-white"
              title="Количество"
              >{{ good.Quantity }}</span
            >
            <span class=" input-group-text" title="Цена без НДС"
              ><b>{{ Math.round(good.Summa/good.Quantity * 100)/100 }}</b></span
            >
            <!--
              <span class=" input-group-text" title="Сумма без НДС">{{good.Summa}}</span>
              <span class=" input-group-text" title="Ставка НДС">{{good.StavkaNDS}}</span>
              <span class=" input-group-text" title="Сумма НДС">{{good.SummaNDS}}</span>
              <span class=" input-group-text" title="Сумма с НДС">{{good.SummaSNDS}}</span>
            -->
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isInvoice">
    <button
      class="input-group-text text-white red hoverable"
      title="Удалить заказ с сервера"
      @click="deleteTransitOrder(supplierTransit);"
      id="basic-text1"
    >
      <i class="fa fa-trash text-grey" aria-hidden="true"></i>
    </button>
  </div>
  </div>
</template>

<script>
// import { mdbBtn } from 'mdbvue'
import ApiService from '@/services/ApiService'
// import { Row, Column, Btn, Card, CardBody, CardHeader, CardText, Fa, mdbTbl, mdbTblHead, mdbTblBody} from 'mdbvue'
export default {
  name: 'transit',
  components: {},
  props: ['ai', 'supplierTransit', 'supplierInvoice', 'mng', 'goods'],
  data () {
    return {
      supplierTransitOrder: [],
      isInvoice: false
    }
  },
  watch: {
    supplierTransit () {
      this.getTransitOrder(this.supplierTransit)
      // this.$emit('supplierInvoice', -1)
      this.isInvoice = false
    },
    supplierInvoice () {
      this.getInvoice(this.supplierInvoice)
      // this.$emit('SupplierTransit', -1)
      this.isInvoice = true
    }
  },
  created () {},
  mounted () {
    console.log('TRANSIT MOUNTED')
    // this.$emit('DateSelected', {dateone: subDays(Date(), 0), datetwo: subDays(Date(), 0)})
  },
  beforeDestroy () {},
  computed: {},
  methods: {
    async getTransitOrder (supplierTransit) {
      let answer = await ApiService.getTransitOrder(supplierTransit)
      this.supplierTransitOrder = answer.data
      this.findNewArticle()
      // console.log(this.supplierTransitOrder)
    },
    findNewArticle () {
      this.supplierTransitOrder.Products.forEach((item, index, array) => {
        if (item.Articul === '') {
          var res = this.goods.filter(good => good.SQCode === item.Code)
          if (res.length > 0 && res[0].Артикул !== '') {
            this.supplierTransitOrder.Products[index].Articul = res[0].Артикул
            this.supplierTransitOrder.Products[index].НаименованиеПолное = res[0].НаименованиеПолное
            console.log(this.supplierTransitOrder.Products[index].Articul)
          }
        } else {
          var res1 = this.goods.filter(good => good.SQCode === item.Code)
          if (res1.length > 0 && res1[0].Артикул !== '') {
            this.supplierTransitOrder.Products[index].Articul = res1[0].Артикул
            this.supplierTransitOrder.Products[index].НаименованиеПолное = res1[0].НаименованиеПолное
          }
        }
      })
    },
    async getInvoice (supplierInvoice) {
      console.log('Получаем накладную ' + supplierInvoice)
      let answer = await ApiService.getInvoice(supplierInvoice)
      this.supplierTransitOrder = answer.data
      this.findNewArticle()
      // console.log(this.supplierTransitOrder)
    },
    async deleteTransitOrder (supplierTransit) {
      let answer = await ApiService.deleteTransitOrder(supplierTransit)
      console.log(answer)
    },
    async changeArticle (code, article) {
      let answer = await ApiService.changeArticle(code, article)
      console.log(answer)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-to-top {
  border-radius: 50%;
  padding: 1rem;
  padding-top: 0.9rem;
  padding-right: 1.1rem;
  padding-bottom: 0.9rem;
  padding-left: 1.1rem;
}
.btn.btn-nav {
  padding: 0.1rem 1rem;
  font-size: 0.64rem;
}
.badge-pill {
  border-radius: 10rem;
  padding-right: 0.6em;
  margin-top: 0.6em;
}
.form-control:focus {
  border: 0px;
}
.form-control {
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Transit.vue